import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import {
  addAchievements,
  removeAchievement,
  setActiveAchievement,
  setIsFetching,
  setListAchievement,
  setPage,
  setTotal,
  updateAchievementById,
  setShowAchievementDetails,
} from './Achievements.slice';
import {
  deleteAchievement,
  fetchAchievements,
  updateAchievement,
} from './Achievements.actions';
import { RootState } from '../../app/store';
import { Unwrap, User } from '../../domains/app';
import AchievementService from '../../service/Achievements.service';
import { Space } from '../Spaces/spaces';

function* fetchAchievementsSaga(action: Action) {
  try {
    yield put(setIsFetching(true));
    if (fetchAchievements.match(action)) {
      const refreshList = action.payload;
      if (refreshList) {
        yield put(setPage(0));
      }
      const page: number = yield select(
        (state: RootState) => state.spaces.page,
      );
      const pageSize: number = yield select(
        (state: RootState) => state.spaces.pageSize,
      );
      const person: User = yield select((state: RootState) => state.app.user);
      const search: string = yield select(
        (state: RootState) => state.spaces.search,
      );

      const res: Unwrap<ReturnType<
        typeof AchievementService.fetchListAchievements
      >> = yield call(
        AchievementService.fetchListAchievements,
        pageSize,
        page,
        person?.id as string,
        search,
      );
      if (refreshList) {
        yield put(setListAchievement([]));
      }
      yield put(addAchievements(res));
      yield put(setTotal(res.length));
      yield put(setPage(page + 1));
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

function* updateAchievementSaga(action: Action) {
  try {
    if (updateAchievement.match(action)) {
      const achievement = action.payload;
      const activeAchievement: Space | undefined = yield select(
        (state: RootState) => state.achievements.activeAchievement,
      );
      if (activeAchievement) {
        yield call(AchievementService.updateAchievement, achievement);

        yield put(updateAchievementById(achievement));
      }

      yield put(setActiveAchievement());
      yield put(setShowAchievementDetails(false));
    }
  } catch (e) {
    console.error(e);
  } finally {
  }
}

function* deleteAchievementSaga(action: Action) {
  try {
    if (deleteAchievement.match(action)) {
      const id = action.payload;
      yield call(AchievementService.deleteAchievement, id);

      yield put(removeAchievement(id));
      yield put(setActiveAchievement());
      yield put(setShowAchievementDetails(false));
    }
  } catch (e) {
    console.error(e);
  } finally {
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([
    takeLatest(fetchAchievements.toString(), fetchAchievementsSaga),
    takeLatest(updateAchievement.toString(), updateAchievementSaga),
    takeLatest(deleteAchievement.toString(), deleteAchievementSaga),
  ]);
}
